<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Custom Game Thumbnail" @show="setUpdateData" @hide="closeModal()">
    <b-card>
      <b-row>
        <b-col sm="12">
          <p-input disabled v-model="form.gameName" label="Game Name" name="gameName" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="6" v-if="form.currentThumb">
          <strong>Current Thumbnail</strong>
          <div class="thumb-wrap">
            <img :src="form.currentThumb.ImgUrl" />
          </div>
        </b-col>
        <b-col sm="6">
          <strong>{{ form.currentThumb ? 'Replace With' : 'Upload Thumbnail' }}</strong>
          <p-image v-model="form.image" name="image" :handler="$v" :formData="form" class="platform-image"/>
          <small class="text-muted">Allowed: jpg, png, svg, webp, gif. Max 1 MB.</small>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col sm="12">
          <b-btn variant="success" @click="submit()">Save</b-btn>
          <b-btn variant="danger" @click="closeModal()">Cancel</b-btn>
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput, PImage } from '../../../components'

export default {
  name: 'UpdateThumbnailModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        gameName: '',
        gameId: '',
        currentThumb: null,
        image: ''
      }
    }
  },
  validations: {
    form: {
      gameName: {},
      image: { required }
    }
  },
  components: {
    PInput,
    PImage
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  methods: {
    setUpdateData () {
      this.form.gameName = this.updateData.GameName
      this.form.gameId = this.updateData.GameId
      this.form.currentThumb = this.updateData.Thumb || null
      this.form.image = ''
    },
    formatBase64 (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = function (event) {
          resolve(event.target.result)
        }
        reader.readAsDataURL(file)
      })
    },
    async submit () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        Events.$emit('loader')
        const image = await this.formatBase64(this.form.image)
        await this.$http.put(this.API_ENDPOINT + '/game/thumbnail/' + this.form.gameId, { image }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Thumbnail saved')
        this.closeModal()
      } catch (err) {
        console.log('this is an error ', err)
        const msg = (err.response && err.response.data && err.response.data.msg) ? err.response.data.msg : 'Something went wrong'
        Events.$emit('alert', VueNotifications.types.error, 'Error', msg)
      } finally {
        Events.$emit('loader')
      }
    },
    closeModal () {
      this.$v.form.$reset()
      this.$emit('closeModal')
    }
  }
}
</script>

<style>
.thumb-wrap img {
  max-width: 200px;
  max-height: 300px;
  filter: drop-shadow(2px 4px 6px black);
}
</style>



// WEBPACK FOOTER //
// src/views/game/thumbnails/UpdateThumbnail.vue